import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-classlink',
    components: {
    },
})

export default class SSOClasslink extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        clientID: {
            name: 'Client ID',
            field: 'b-form-input',
            modelKey: 'clientID',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        clientSecret: {
            name: 'Client Secret',
            field: 'b-form-input',
            modelKey: 'clientSecret',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };
}
